import { isAxiosError } from './isAxiosError';

/**
 * True when a request failed with the server's `quiz_not_found` error. On the
 * report/quiz pages this is what's returned when the quiz can't be loaded
 * because its shared library was deleted or the user lost access. Keyed on the
 * error code so genuine network/server errors fall through to the default UI.
 */
export function isQuizNotFoundError(error: unknown): boolean {
  return (
    isAxiosError(error) &&
    (error.response?.data as { code?: string } | undefined)?.code ===
      'quiz_not_found'
  );
}
